import { Button, Stack, Typography, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	reminder: Reminder;
	open: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

export const ReminderDeleteConfirmDrawer = ({
	reminder,
	open,
	onConfirm,
	onClose,
}: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			grabber
			title={t(Resources.Reminders.DeleteConfirm.title)}
		>
			<Stack
				px={theme.spacingTokens.lg}
				pb={theme.spacingTokens.lg}
				gap={theme.spacingTokens.lg}
			>
				<Typography variant="body2">
					{t(Resources.Reminders.DeleteConfirm.description, {
						name: reminder.name,
					})}
				</Typography>
				<Stack gap={theme.spacingTokens.xs}>
					<Button variant="primary" onClick={onConfirm}>
						{t(Resources.Reminders.DeleteConfirm.confirm)}
					</Button>
					<Button
						variant="textLink"
						color="neutral"
						fullWidth
						onClick={onClose}
						sx={{ justifyContent: "center", py: theme.spacingTokens.sm }}
					>
						{t(Resources.Reminders.DeleteConfirm.cancel)}
					</Button>
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
